import { FormControl, FormErrorMessage, FormLabel, Text, VStack } from "@chakra-ui/react";
import { Select, chakraComponents, OptionProps } from "chakra-react-select";
import { selectChakraStyles } from "utils/constants";
import { SelectOption } from "utils/types";
import { useChecklist } from "hooks/useChecklist";

const customComponents = {
  Option: ({ children, ...props }: OptionProps) => {
    const data: {
      label: string;
      borrower_company: string;
    } = props.data as any;
    return (
      <chakraComponents.Option {...props}>
        <VStack alignItems="flex-start" spacing="0px">
          <Text display="block">{data.label}</Text>
          <Text fontSize="13px">{data.borrower_company}</Text>
        </VStack>
      </chakraComponents.Option>
    );
  },
};

const CategoriesField = ({
  category,
  setCategory,
  isMulti,
  isRequired = false,
  loan_id,
}: {
  category: SelectOption | null;
  setCategory: (payload: SelectOption | null) => void;
  isMulti?: boolean;
  isRequired?: boolean;
  loan_id?: string;
}) => {
  const { categories, isLoading } = useChecklist({
    loan_id,
  });

  const options = categories?.map(record => ({
    label: record,
    value: record,
  }));

  return (
    <>
      <FormControl
        mb="24px"
        isRequired={isRequired}
        isInvalid={isRequired && !category}
        isDisabled={isLoading}
      >
        <FormLabel>Select the Checklist category</FormLabel>
        <FormErrorMessage>Please select the Checklist category for the document</FormErrorMessage>
        <Select
          isMulti={isMulti}
          useBasicStyles
          noOptionsMessage={() => "No categories found."}
          selectedOptionColor="black"
          colorScheme="purple"
          variant="outline"
          chakraStyles={selectChakraStyles}
          value={category}
          onChange={(newValue: SelectOption | unknown) =>
            setCategory(newValue as SelectOption | null)
          }
          options={options}
          components={customComponents}
        />
      </FormControl>
    </>
  );
};

export default CategoriesField;
